import { NavLink } from "react-router-dom";
import { gameCategories, parentGuides } from "./content";
import usePageMetadata from "./usePageMetadata";

export default function MarketingHome() {
    usePageMetadata({
        title: "Fun Math Games for Kids",
        description: "Explore MathMinds math and brain games for children, with activities for counting, addition, multiplication, fractions, memory, and more.",
    });

    return (
        <>
            <section className="overflow-hidden bg-[linear-gradient(180deg,#FFF8DF_0%,#FCF9EE_100%)]">
                <div className="mx-auto grid max-w-[1200px] items-center gap-10 px-5 py-16 sm:px-8 md:grid-cols-2 md:py-24">
                    <div>
                        <p className="font-bold uppercase tracking-[0.18em] text-[#C37C00]">Learn through play</p>
                        <h1 className="mt-4 max-w-2xl font-chango text-4xl leading-tight text-[#327560] sm:text-5xl lg:text-6xl">
                            Fun math games that grow with your child
                        </h1>
                        <p className="mt-6 max-w-xl text-lg leading-8 text-[#56635E]">
                            Practice number skills, memory, logic, and problem solving with colorful games made for children ages 4–12.
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <NavLink to="/games/memory" className="rounded-full bg-[#F9B818] px-7 py-3.5 font-bold shadow-sm hover:bg-[#FFCA47]">
                                Start playing
                            </NavLink>
                            <NavLink to="/math-games/" className="rounded-full border-2 border-[#327560] px-7 py-3 font-bold text-[#327560] hover:bg-[#E8F3EC]">
                                Parent guides
                            </NavLink>
                        </div>
                    </div>
                    <div className="relative mx-auto w-full max-w-lg rounded-[3rem] bg-[#DDF5ED] p-8 shadow-[0_20px_60px_rgba(50,117,96,0.16)]">
                        <img src="/backGrounds/welcome_message.png" alt="MathMinds characters welcoming children to learn" className="mx-auto w-full" />
                    </div>
                </div>
            </section>

            <section className="mx-auto max-w-[1200px] px-5 py-16 sm:px-8">
                <div className="max-w-2xl">
                    <p className="font-bold uppercase tracking-[0.18em] text-[#C37C00]">Choose a skill</p>
                    <h2 className="mt-3 font-chango text-3xl text-[#327560] sm:text-4xl">Math and brain games</h2>
                    <p className="mt-4 leading-7 text-[#56635E]">Go directly to a game category and choose an activity at the right level.</p>
                </div>
                <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {gameCategories.map((category) => (
                        <NavLink key={category.name} to={category.path} className={`${category.color} rounded-3xl p-6 text-xl font-bold transition-transform hover:-translate-y-1`}>
                            {category.name}<span aria-hidden="true" className="float-right">→</span>
                        </NavLink>
                    ))}
                </div>
            </section>

            <section className="bg-white/70">
                <div className="mx-auto max-w-[1200px] px-5 py-16 sm:px-8">
                    <p className="font-bold uppercase tracking-[0.18em] text-[#C37C00]">For parents</p>
                    <div className="mt-3 flex flex-wrap items-end justify-between gap-4">
                        <h2 className="font-chango text-3xl text-[#327560] sm:text-4xl">Find games for your child</h2>
                        <NavLink to="/math-games/" className="font-bold text-[#327560] hover:underline">View all parent guides →</NavLink>
                    </div>
                    <div className="mt-8 grid gap-5 md:grid-cols-3">
                        {parentGuides.slice(0, 3).map((guide) => (
                            <NavLink key={guide.path} to={guide.path} className="rounded-3xl border border-[#E9E2CD] bg-[#FCF9EE] p-6 shadow-sm transition hover:border-[#86B7A5]">
                                <h3 className="text-xl font-bold text-[#327560]">{guide.label}</h3>
                                <p className="mt-3 leading-7 text-[#56635E]">{guide.description}</p>
                            </NavLink>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
